import { createClient } from "@supabase/supabase-js";

// NEXT_PUBLIC_SUPABASE_URL=https://vbeuugnmyhndvgmlkzdj.supabase.co
// NEXT_PUBLIC_SUPABASE_ANON_KEY=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZiZXV1Z25teWhuZHZnbWxremRqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTYxMTQ0MTMsImV4cCI6MjA3MTY5MDQxM30.JRua1VvK6DsmpDReK3cyRpZXYZn8HCp2sskEebNbMt8
// 


const SUPABASE_URL = "https://vbeuugnmyhndvgmlkzdj.supabase.co"; // replace with your Supabase project URL
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZiZXV1Z25teWhuZHZnbWxremRqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTYxMTQ0MTMsImV4cCI6MjA3MTY5MDQxM30.JRua1VvK6DsmpDReK3cyRpZXYZn8HCp2sskEebNbMt8"; // replace with your anon key

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
